import React from "react";
import { useTable } from "../../Components/useTable";

const MomentReport = () => {
  const type = "Reported Moments";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "reportname", numeric: false, label: "Reporter Name" },
    { id: "reportcode", numeric: false, label: "Reporter RID" },
    { id: "pictureUrl", numeric: false, label: "Reporter Image" },
    { id: "reason", numeric: false, label: "Reason" },
    { id: "imageUrl1", numeric: false, label: "Uploaded Image" },
    { id: "postUserName", numeric: false, label: "User Name" },
    { id: "postUserCode", numeric: false, label: "User RID" },
    { id: "picture", numeric: false, label: "User Pic" },
    { id: "createdAt", numeric: false, label: "Date" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default MomentReport;
